import React from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import Image from 'components/Image';
import { MQ_LARGE, MQ_MIDLARGE, MQ_MEDIUM } from 'constants/mq';
import ActionIcon from 'components/ActionIcon';
import styles from './styles';

export const PROFILE_IMAGE_SIZES = [
  {
    media: MQ_MIDLARGE,
    layoutWidth: {
      value: 500,
      units: 'px'
    }
  },
  {
    media: MQ_LARGE,
    layoutWidth: {
      value: 500,
      units: 'px'
    }
  },
  {
    media: MQ_MEDIUM,
    layoutWidth: {
      value: 500,
      units: 'px'
    }
  },
  {
    layoutWidth: {
      value: 100,
      units: 'vw'
    }
  }
];

export function conditionallyWrapWithAuthorLink(WrappedComponent) {
  return function withAuthorLink(props) {
    return props.wrapWithLink ? (
      <a href={props.authorUrl}>
        <WrappedComponent {...props} />
      </a>
    ) : (
      <WrappedComponent {...props} />
    );
  };
}

export function PersonProfile(props) {
  const {
    name,
    imageUrl,
    jobTitle,
    location,
    bio,
    instagramUrl,
    twitterUrl,
    pinterestUrl,
    personalUrl,
    email,
    variant
  } = props;

  return (
    <div
      className={classnames('PersonProfile', {
        [`PersonProfile--${variant}`]: variant
      })}
    >
      {imageUrl && (
        <div className="PersonProfile__image">
          <Image
            url={imageUrl}
            alt={`${name}'s profile picture`}
            sourceSizes={PROFILE_IMAGE_SIZES}
            maxSize={{ width: 500, aspectRatio: 1 }}
          />
        </div>
      )}
      <div className="PersonProfile__info">
        <h1 className="PersonProfile__name">{name}</h1>
        {jobTitle && (
          <p
            className="PersonProfile__title"
            dangerouslySetInnerHTML={{ __html: jobTitle }}
          />
        )}
        {location && <p className="PersonProfile__location">{location}</p>}
        {bio && (
          <div
            className="PersonProfile__bio"
            dangerouslySetInnerHTML={{ __html: bio }}
          />
        )}
        <ul className="PersonProfile__links">
          {instagramUrl && (
            <li>
              <ActionIcon
                url={instagramUrl}
                type="instagram"
                variant="branded"
              />
            </li>
          )}
          {twitterUrl && (
            <li>
              <ActionIcon url={twitterUrl} type="twitter" variant="branded" />
            </li>
          )}
          {pinterestUrl && (
            <li>
              <ActionIcon
                url={pinterestUrl}
                type="pinterest"
                variant="branded"
              />
            </li>
          )}
          {personalUrl && (
            <li>
              <ActionIcon url={personalUrl} type="external" variant="branded" />
            </li>
          )}
          {email && (
            <li>
              <ActionIcon
                url={`mailto:${email}`}
                type="email"
                variant="branded"
              />
            </li>
          )}
        </ul>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}

PersonProfile.propTypes = {
  name: string.isRequired,
  imageUrl: string,
  jobTitle: string,
  location: string,
  bio: string,
  instagramUrl: string,
  twitterUrl: string,
  pinterestUrl: string,
  personalUrl: string,
  email: string,
  variant: string
};

PersonProfile.defaultProps = {
  imageUrl: undefined,
  jobTitle: undefined,
  location: undefined,
  bio: undefined,
  instagramUrl: undefined,
  twitterUrl: undefined,
  pinterestUrl: undefined,
  personalUrl: undefined,
  email: undefined,
  variant: undefined
};

export default conditionallyWrapWithAuthorLink(PersonProfile);
